export const normalizePercent = (value) => {
    if (!Number.isFinite(Number.parseFloat(value))) return null

    return Math.max(0, Math.min(100, Number.parseFloat(value)))
}

const firstNumeric = (values) => values.find((value) => Number.isFinite(Number.parseFloat(value)))

export const healthScoreFromPresentation = (source) => {
    const rawHealth = firstNumeric([source?.health_score, source?.health?.percent, source?.healthLevel])
    if (rawHealth !== undefined) return Math.round(normalizePercent(rawHealth))

    const rawConfidence = firstNumeric([
        source?.anomaly_confidence_level_percent,
        source?.anomaly_confidence_level,
        source?.anomaly_confidence,
        source?.score,
    ])
    if (rawConfidence === undefined) return null

    let confidenceLevel = Number.parseFloat(rawConfidence)
    if (!Number.isFinite(confidenceLevel)) return null

    if (confidenceLevel >= 0 && confidenceLevel <= 1) {
        confidenceLevel *= 100
    }

    return 100 - Math.round(normalizePercent(confidenceLevel))
}
